const $ = require('jquery');
const MAX_HEIGHT = 915;
const HERO_CLASS = '.homepage-tabs';
let tweets_loaded = false;

$(window).on('load', ()=>{
  checkHeights();
});

$( '.homepage-tabs .jquery-tabs' ).on( 'tabsactivate', ( event, ui )=> {
  // checkHeights();
  // tweets are loaded async so we need to wait a beat before checking height
  // small race condition but ¯\_(ツ)_/¯
  setTimeout(function(){
    checkHeights();
  }, 250);
});

function checkHeights() {
  const heroHeight = $(HERO_CLASS).outerHeight(true);

  if (heroHeight > MAX_HEIGHT) {
    $(HERO_CLASS).addClass('overflown');
  } else {
    $(HERO_CLASS).removeClass('overflown');
  }
}
